<template>
    <div :class="'col-md-'+ col">
        <a :href="link">
            <div :class="'card card-stats ' + color" style="min-height: 100px;">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12 text-center pt-2">
                            <span class="text-white">{{ name }}</span>

                            <div v-if="actions" class="dropdown" style="position:absolute; right: 5px; top: 0">
                                <i data-toggle="dropdown" class="now-ui-icons loader_gear text-white"></i>
                                <div class="dropdown-menu dropdown-menu-right" x-placement="top-end"
                                     style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-122px, -60px, 0px);">
                                    <slot name="dropdown-item"></slot>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 text-center">
                            <h2 class="font-weight-bold text-white mb-0">
                                {{ value }}
                            </h2>
                        </div>
                    </div>
                    <p class="mt-3 mb-0 text-sm cursor-default"><span
                        class="text-white">{{ label }}</span> <span
                        class="el-tooltip text-white font-weight-bold float-right"
                        aria-describedby="el-tooltip-152" tabindex="0"> {{
                            total && value ? `${value} / ${total}` : ''
                        }}</span>
                    </p>
                </div>
                <span v-if="loading" class="fa fa-sync"></span>
            </div>
        </a>
    </div>
</template>

<script>

export default {
    name: "DashboardCardComponent",
    props: {
        col: {
            type: String,
            default: '3'
        },
        name: {
            type: String,
            default: ''
        },
        total: {
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: 'bg-gradient-info'
        },
        module: {
            type: String,
            default: 'home'
        },
        tag: {
            type: String,
            default: 'home'
        },
        link: {
            type: String,
            default: '#'
        },
        actions: {
            type: Boolean,
            default: false
        },
        otherParams: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            value: 0,
            loading: true,
        }
    },
    watch: {},
    mounted() {
        this.getTotal()
    },
    methods: {
      async  getTotal() {
            let app = this;
           await axios.post('/dashboard-total', {
                module: this.module,
                tag: this.tag,
            }).then(function (response) {
                app.value = response.data
            }).finally(() => {
                app.loading = false;
            })
        }
    }
}
</script>

<style scoped>
.card-stats {
    position: relative;
}

.card-stats > .fa-sync {
    position: absolute;
    right: 10px;
    bottom: 5px;
    color: white;
    opacity: 0.3;
    font-size: 1.5em;
    animation: rotate 2s linear infinite;
}


@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
